'use client';

import { ComponentProps } from 'react';

import { cx } from '@/ui/cva';

import { useField } from './context';

type FieldErrorProps = Omit<ComponentProps<'div'>, 'children'>;

export function FieldError({ className, ...props }: FieldErrorProps) {
    const { error, id } = useField();

    if (!error) {
        return null;
    }

    return (
        <div
            className={cx(
                'mt-2xs text-sm text-error transition',
                'border-x-1 border-transparent px-sm',
                className
            )}
            id={`${id}-error`}
            {...props}
        >
            {error}
        </div>
    );
}
